export function joinWithAnd(items: string[]): string {
  const filteredItems = items.filter(item => item.trim() !== '');

  if (filteredItems.length === 0) {
    return '';
  }

  if (filteredItems.length === 1) {
    return filteredItems[0];
  }

  if (filteredItems.length === 2) {
    return `${filteredItems[0]} and ${filteredItems[1]}`;
  }

  const allButLast = filteredItems.slice(0, -1);
  const lastItem = filteredItems.at(-1)!;

  return `${allButLast.join(', ')} and ${lastItem}`;
}
